import React, { Component, Fragment } from 'react';
import TextInputMask from 'react-masked-text';

class Input extends Component {
  static defaultProps = {
    errors: null,
    mask: null,
    focus: 0,
  };

  state = {
    className: 'input',
  };

  componentDidMount() {
    // Focus masked inputs
    this.props.mask !== null && !!this.props.focus && this.input._input.focus();

    // Focus standard inputs.
    this.props.mask === null && !!this.props.focus && this.input.focus();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.errors !== null) {
      this.setState({ className: 'input parsley-error' });
    } else {
      this.setState({ className: 'input' });
    }
  }

  render() {
    return (
      <Fragment>
        {this.props.mask === null ? (
          <input
            ref={input => {
              this.input = input;
            }}
            type="text"
            className={this.state.className}
            {...this.props}
          />
        ) : (
          <TextInputMask
            ref={input => {
              this.input = input;
            }}
            className={this.state.className}
            kind={this.props.mask}
            onChangeText={this.props.onChange}
            {...this.props}
          />
        )}

        {this.props.errors !== null && <span className="helper">{this.props.errors.join(', ')}</span>}
      </Fragment>
    );
  }
}

export default Input;
